{
  "name": "mitgliederportal",
  "version": "1.4.5",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "prebuild": "npm --no-git-tag-version version patch",
    "build": "ng build",
    "test": "ng test",
    "lint": "ng lint",
    "e2e": "ng e2e",
    "i:gcp": "powershell -ExecutionPolicy Bypass -File npm-install-gcp.ps1"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^18.0.6",
    "@angular/cdk": "^18.1.1",
    "@angular/common": "^18.0.6",
    "@angular/compiler": "^18.0.6",
    "@angular/core": "^18.0.6",
    "@angular/forms": "^18.0.6",
    "@angular/material": "^18.1.1",
    "@angular/material-moment-adapter": "^18.1.1",
    "@angular/platform-browser": "^18.0.6",
    "@angular/platform-browser-dynamic": "^18.0.6",
    "@angular/router": "^18.0.6",
    "@nrwl/angular": "^19.1.0",
    "angular-calendar": "^0.30.1",
    "date-fns": "^2.29.1",
    "ng-qrcode": "^18.0.0",
    "ngx-editor": "^18.0.0",
    "ngx-toastr": "^16.2.0",
    "prosemirror-commands": "^1.6.0",
    "prosemirror-history": "^1.4.1",
    "prosemirror-model": "^1.23.0",
    "prosemirror-schema-list": "^1.4.1",
    "prosemirror-state": "^1.4.3",
    "prosemirror-transform": "^1.10.0",
    "prosemirror-view": "^1.34.3",
    "rxjs": "~7.8.1",
    "tslib": "^2.0.0",
    "zone.js": "~0.14.7",
    "@trivelope/triv-ui-tools-lib": "^18.0.5"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^18.1.0",
    "@angular/cli": "^18.0.7",
    "@angular/compiler-cli": "^18.0.6",
    "@angular/localize": "^18.0.6",
    "@types/jasmine": "~3.8.0",
    "@types/node": "^12.11.1",
    "jasmine-core": "~3.8.0",
    "jasmine-spec-reporter": "~5.0.0",
    "karma": "~6.4.1",
    "karma-chrome-launcher": "~3.1.0",
    "karma-coverage": "~2.0.3",
    "karma-jasmine": "~4.0.0",
    "karma-jasmine-html-reporter": "^1.5.0",
    "node-less": "^1.0.0",
    "ts-node": "~10.9.1",
    "typescript": "^5.1.6"
  }
}
